module.exports = __webpack_public_path__ + "img/29.f93fd20f.png";